import { get as getAPICall } from 'aws-amplify/api';
import { errorHandler } from "./Api";

const { PACKAGE_NOTIFICATIONS, PACKAGE_NOTIFICATIONS_SUBJECT } = require("./Constants");

export const sendEmailNotification = async (notificationType, data, recipient) => {
    if (recipient) {
        const queryParameters = getEmailData(notificationType, data, recipient);

        const getPayload = {
            apiName: "pinpoint",
            path: "/notification",
            options: {
                queryParams: queryParameters
            }

        };
        const restOperation = await getAPICall(getPayload).response;
        const response = await restOperation.body.json();
        if (response.emailSend !== 1) {
            errorHandler(queryParameters, `Error al enviar la notificacion ${notificationType}`);
        }

    }
}

const getEmailData = (notificationType, data, recipient) => {
    const emailTemplateData = getEmailTemplateData();
    const recipientData = getRecipientData(recipient);
    const subject = PACKAGE_NOTIFICATIONS_SUBJECT[notificationType];
    const defaultData = {
        ...emailTemplateData,
        ...recipientData,
        subject,
        templateName: notificationType

    }
    if (PACKAGE_NOTIFICATIONS.PACKAGE_RECEIVED === notificationType) {
        const { tracking_num, courier, secuencia } = data;
        return {
            ...defaultData,
            tracking_num,
            courier,
            secuencia
        }
    } else if (PACKAGE_NOTIFICATIONS.PACKAGE_ON_STATUS_CHANGE === notificationType) {
        const { tracking_num, courier, status, secuencia } = data;
        return {
            ...defaultData,
            tracking_num,
            courier,
            status,
            secuencia
        }
    } else if (PACKAGE_NOTIFICATIONS.PACKAGE_READY_TO_PICK_UP === notificationType) {
        const { tracking_num, courier, address, secuencia } = data;
        return {
            ...defaultData,
            tracking_num,
            courier,
            address,
            secuencia
        }
    } else if (PACKAGE_NOTIFICATIONS.PACKAGE_ON_ROUTE === notificationType) {
        const { tracking_num, courier, secuencia } = data;
        return {
            ...defaultData,
            tracking_num,
            courier,
            secuencia
        }
    } else if (PACKAGE_NOTIFICATIONS.PACKAGE_COST === notificationType) {
        const { tracking_num, courier, secuencia, shippingCost, taxCost,
            localShippingCost, subtotal, iva, total } = data;
        return {
            ...defaultData,
            tracking_num,
            courier,
            secuencia,
            shippingCost,
            taxCost,
            localShippingCost,
            subtotal,
            iva,
            total
        }
    }

}

const getEmailTemplateData = () => {
    const todaysDate = new Date()
    const currentYear = todaysDate.getFullYear()
    let today = todaysDate.toLocaleDateString();
    return {
        currentYear,
        today
    }
}

const getRecipientData = (recipient) => {
    const { name, email: toAddresses } = recipient;
    return { name, toAddresses };
}